module.exports = "\t<span class=\"c-cover-image__mask\"></span>\n\t<div class=\"c-cover-image__container\">\n\t\t<ng-content></ng-content>\n\t</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/cover-image/cover-image.component.html
// module id = ./src/app/modules/common-module/components/cover-image/cover-image.component.html
// module chunks = 9